module.exports = __webpack_public_path__ + "a749f5837a401a0eafe8cc0621cfc909.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/money.png
 ** module id = 1573
 ** module chunks = 0
 **/